import { useAppSelector } from '../store/hooks'
import AssetConcentrationStateless from '../templates/asset-concentration-stateless'

export const AssetConcentrationPage = () => {
  const state = useAppSelector(x => x.gapRisk)

  return <AssetConcentrationStateless report={state.assetConcentration} />
}
